import styled from 'styled-components'
import {
  Typography,
  SubmitButton as SubmitButtonDefault,
  Title as TitleDefault,
  Checkbox as CheckboxDefault,
  WrapperRelative as WrapperRelativeDefault,
} from '~components'

export const Link = styled.a`
  cursor: pointer;
  text-decoration: none;
  font-size: ${({ theme }) => theme.font.size.m2};
  color: ${({ theme }) => theme.brand.text.default};
  font-weight: ${({ theme }) => theme.font.weight.medium};
`

export const Title = styled(TitleDefault)`
  margin-bottom: ${({ theme }) => theme.spacing.km8};
`

export const Checkbox = styled(CheckboxDefault)`
  margin-bottom: ${({ theme }) => theme.spacing.km8};
`

export const SpaceCheck = styled.div`
  margin-top: 26px;
`

export const SubmitButton = styled(SubmitButtonDefault)`
  margin-bottom: ${({ theme }) => theme.spacing.km8};
`

export const WrapperRelative = styled(WrapperRelativeDefault)`
  input:not(:last-child) {
    padding: ${({ theme }) => theme.spacing.km0} ${({ theme }) => theme.spacing.km10}
      ${({ theme }) => theme.spacing.km0} ${({ theme }) => theme.spacing.km3};
  }

  &
    > input:not(:focus)
    + svg:is([aria-label='show-password'], [aria-label='hide-password']) {
    & > path {
      stroke: #7b829d;
    }
  }

  &
    > input:not(:placeholder-shown)
    + svg:is([aria-label='show-password'], [aria-label='hide-password']) {
    & > path {
      stroke: #232b43;
    }
  }
`

export const Message = styled(Typography).attrs({ as: 'p' })`
  font-weight: ${({ theme }) => theme.font.weight.medium};
  color: ${({ theme }) => theme.neutral.text.default};
`
